import React from "react";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import downloadTokens from "@amzn/meridian-tokens/base/icon/download-large";
import { GetShiftPlanOutputResponse } from "../../../reviewAndPublish/model";
import { downloadPlanPdf, PlanPdfMetadata } from "./downloadPlanPdf";

/**
 * "Download Plan" action (UTR-REFLEX-1163) — exports the selected plan as a PDF,
 * generated client-side from the shiftPlanOutput data. Disabled until a plan's
 * output is available. Meridian components only.
 */
interface DownloadPlanButtonProps {
  shiftPlanOutput?: GetShiftPlanOutputResponse;
  metadata: PlanPdfMetadata;
}

const DownloadPlanButton: React.FC<DownloadPlanButtonProps> = ({ shiftPlanOutput, metadata }) => {
  const handleDownload = () => {
    if (!shiftPlanOutput) {
      return;
    }
    downloadPlanPdf(shiftPlanOutput, metadata);
  };

  return (
    <Button type="primary" size="medium" disabled={!shiftPlanOutput} onClick={handleDownload}>
      <Icon tokens={downloadTokens} />
      Download Plan
    </Button>
  );
};

export default DownloadPlanButton;
